// extracted by mini-css-extract-plugin
export default {"formSection":"AddContentItemModal__formSection-FdYMP"};